export function SettingsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/settings.svg'"></ng-include>`
    }
}